<!--
 * @Description: 路网态势感知平台
 * @Author: ChangWenBo (649160016@qq.com)
 * @Date: 2021-03-16 14:52:22
 * @LastEditors: ChangWenBo (649160016@qq.com)
 * @LastEditTime: 2021-04-20 18:27:07
 -->
<template>
  <div class="roadNetworkSituationAwareness">
    <div class="platFormIntroduceBtn" @click="detailShowSwitch">平台介绍</div>
    <transition name="el-zoom-in-center">
      <div class="platFormIntroduceDetail" v-if="showDetail">
        <span class="closeBtn el-icon-close" @click="closePdfView"></span>
        <iframe :src="pdfUrl + '#scrollbars=0&toolbar=0&statusbar=0'" frameborder="0" scrolling="no"></iframe>
      </div>
    </transition>
    <div class="line1">
      <Line1 />
    </div>
    <div class="line2">
      <Line2 />
    </div>
    <div class="line3">
      <div class="line3-left">
        <div class="line3-left-top">
          <Line3LeftTop />
        </div>
        <div class="line3-left-bottom">
          <Line3LeftBottom />
        </div>
      </div>
      <div class="line3-right">
        <div class="line3-right-top">
          <Line3RightTop />
        </div>
        <div class="line3-right-bottom">
          <Line3RightBottom />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Line1 from './components/line1'
import Line2 from './components/line2'
import Line3LeftTop from './components/line3LeftTop'
import Line3LeftBottom from './components/line3LeftBottom'
import Line3RightTop from './components/line3RightTop'
import Line3RightBottom from './components/line3RightBottom'
export default {
  name: 'roadNetworkSituationAwareness',
  components: {
    Line1,
    Line2,
    Line3LeftTop,
    Line3LeftBottom,
    Line3RightTop,
    Line3RightBottom,
  },
  data () {
    return {
      showDetail: false,
      pdfUrl: 'https://bigdata-v.prod.hndfsj.net/lwtsgz.pdf',
    }
  },
  methods: {
    /**
     * @description                   平台介绍详细信息的打开与隐藏
     * @return {undefied}             无返回值
     */
    detailShowSwitch () {
      this.showDetail = !this.showDetail
    },
    /**
     * @description                   关闭平台介绍
     * @return {undefied}             无返回值
     */
    closePdfView () {
      this.showDetail = false
    },
  },
  created () {
  },
}
</script>

<style lang="less" scoped>
  .roadNetworkSituationAwareness {
    width: 100%;
    height: 100%;
    position: relative;
    .platFormIntroduceBtn {
      display: inline-block;
      width: 132px;
      height: 70px;
      background: url('/static/img/layout/platformIntroduceBg.png');
      background-size: 100% 100%;
      position: absolute;
      top: 300px;
      left: 0;
      text-align: center;
      font-size: 20px;
      color: #fff;
      font-weight: bold;
      cursor: pointer;
      line-height: 70px;
    }
    .platFormIntroduceDetail {
      width: 800px;
      height: 900px;
      padding-top: 30px;
      overflow-y: scroll;
      // background: url('/static/img/layout/platformIntroduceDetailBg.png');
      // background-size: 100% 100%;
      position: absolute;
      top: 150px;
      left: 130px;
      color: #d7fdff;
      font-size: 18px;
      line-height: 24px;
      z-index: 10000;
      .closeBtn {
        display: inline-blockl;
        width: 20px;
        height: 20px;
        cursor: pointer;
        font-size: 30px;
        position: absolute;
        right: 5px;
        top: 0;
        z-index: 10000000;
      }
      iframe {
        width: 100%;
        height: calc(100% - 20px);
        border-radius: 10px;
        ::-webkit-scrollbar-thumb {
          cursor: pointer;
          box-shadow: inset 0 0 6px #106669;
          background-color: #05dbe3;
          border-radius: 4px;
        }

        ::-webkit-scrollbar:hover {
          width: 5px;
          height: 10px;
        }

        ::-webkit-scrollbar-corner {
          background-color: #181f27;
        }
      }
    }
    .line1 {
      width: calc(100% - 224px);
      height: 284px;
      padding: 0 112px;
      margin-bottom: 70px;
    }
    .line2 {
      width: 100%;
      height: 694px;
      margin-bottom: 50px;
    }
    .line3 {
      width: 100%;
      height: 627px;
      display: inline-flex;
      justify-content: space-between;
      .line3-left {
        width: 51%;
        height: 100%;
        .line3-left-top {
          width: 100%;
          height: 35%;
        }
        .line3-left-bottom {
          width: 100%;
          height: 65%;
        }
      }
      .line3-right {
        width: 46%;
        height: 100%;
        .line3-right-top {
          width: 100%;
          height: 50%;
        }
        .line3-right-bottom {
          width: 100%;
          height: 50%;
        }
      }
    }
  }
</style>
